///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, consignationActionsCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { POST_CONSIGNATION as postCons } from '../../constants/Endpoint'
import { API_TOKEN, API_TOKEN_DL_FILE } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postConsignation = function* ({ payload }) {
	const data = payload

	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(postCons(payload.queryParams), bodyMsg)

		yield put(consignationActionsCreators.postConsignationSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(consignationActionsCreators.postConsignationFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateCustomerInfos = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const id = payload.row.saleOrderId
	const codeKiosk = payload.row.codeKiosk

	const apiCall = R.UPDATE_CUSTOMER_INFOS()
	const customer = {
		userKioskScope: {
			kiosksInLocalScope: payload.kioskId,
		},
		salesOrderId: id,
		customerInfos: {
			customerFirstName: payload.consignation.firstName,
			customerLastName: payload.consignation.lastName,
			customerEmail: payload.consignation.mail,
		},
	}

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, customer)

		yield put(consignationActionsCreators.updateCustomerInfosSuccess(customer))

		yield put(toastSuccessActionCreators.hydrateToast('toast__transactionsHistory__admin__consignmentContract__updateFailed_body'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(consignationActionsCreators.updateCustomerInfosSuccessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sendConsignementContract = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SEND_CONSIGNEMENT_CONTRACT(payload.idContract)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(consignationActionsCreators.sendConsignementContractSuccess(data.data, payload.idContract))
		yield put(toastSuccessActionCreators.hydrateToast('toast__transactionsHistory__admin__consignmentContract__sendSuccess_body'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(consignationActionsCreators.sendConsignementContractFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const viewConsignementContract = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.VIEW_CONSIGNEMENT_CONTRACT(payload.idContract)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN_DL_FILE(user.jwt).put(apiCall)

		const type = 'application/pdf'

		const url = window.URL.createObjectURL(new Blob([data.data], { type: type }))

		window.open(url, 'blank')

		yield put(consignationActionsCreators.viewConsignementContractSuccess(data.data, payload.idContract))
		//yield put(toastSuccessActionCreators.hydrateToast('page__transactionsHistory__admin__consignmentContract__modalSendSuccess_body'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(consignationActionsCreators.viewConsignementContractFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_CONSIGNATION, postConsignation)
	yield takeLatest(ActionsTypes.UPDATE_CUSTOMER_INFOS, updateCustomerInfos)
	yield takeLatest(ActionsTypes.SEND_CONSIGNEMENT_CONTRACT, sendConsignementContract)
	yield takeLatest(ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT, viewConsignementContract)
}

export default sagas
